import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Printer, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import InvoiceSheet from "@/components/InvoiceSheet";
import { api, errMsg } from "@/lib/api";

export default function InvoiceBulkPrint() {
  const [sp] = useSearchParams();
  const ids = (sp.get("ids") || "").split(",").filter(Boolean);
  const [docs, setDocs] = useState(null);
  const [co, setCo] = useState({});
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!ids.length) { setErr("Yazdırılacak fatura seçilmedi"); return; }
    Promise.all(ids.map(async (id) => {
      const inv = (await api.get(`/invoices/${id}`)).data;
      const acc = await api.get(`/accounts/${inv.account_id}`).then((r) => r.data).catch(() => ({}));
      return { inv, acc };
    })).then(setDocs).catch((e) => setErr(errMsg(e)));
    api.get("/company").then((r) => setCo(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sp]);

  useEffect(() => {
    if (!docs || sp.get("print") !== "1") return undefined;
    const t = setTimeout(() => window.print(), 800);
    return () => clearTimeout(t);
  }, [docs, sp]);

  if (err) return <div className="flex h-screen flex-col items-center justify-center gap-2" data-testid="bulk-print-error"><div className="font-display text-2xl font-bold">Toplu yazdırma yapılamadı</div><div className="text-sm text-muted-foreground">{err}</div></div>;
  if (!docs) return <div className="flex h-screen items-center justify-center label-eyebrow">Faturalar hazırlanıyor…</div>;

  return (
    <div className="min-h-screen bg-teal-900/10 py-8 print:bg-white print:py-0" data-testid="bulk-print-page">
      <div className="no-print mx-auto mb-4 flex max-w-[210mm] items-center justify-between gap-2 px-2">
        <span className="text-sm font-semibold" data-testid="bulk-print-count">{docs.length} fatura</span>
        <div className="flex gap-2">
          <Button onClick={() => window.print()} className="rounded-[4px] bg-teal-700 hover:bg-teal-800" data-testid="bulk-print-button"><Printer /> Tümünü Yazdır</Button>
          <Button variant="outline" onClick={() => window.close()} className="rounded-[4px] bg-white" data-testid="bulk-print-close-button"><X /> Kapat</Button>
        </div>
      </div>
      {docs.map(({ inv, acc }, i) => (
        <div key={inv.id} className={i < docs.length - 1 ? "mb-8 break-after-page print:mb-0" : ""}>
          <InvoiceSheet d={inv} acc={acc} co={co} testid={`bulk-invoice-${inv.no}`} />
        </div>
      ))}
    </div>
  );
}
